import Button from "../../../Buttons/Button";
import React, {
  FormEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useForm } from "react-hook-form";
import { secondary } from "../../../../theme";
import { useApi } from "../../../../hooks/api";
import { Column } from "../../../../style";
import { useGlobal } from "../../../../hooks/global";
import { ModalLoading } from "../../../Loadings/ModalLoading";
import { ContainerButtons, ContainerForm, Form } from "./style";
import { IGroupProps, userProps } from "../../../../interfaces";
import { validateEmail } from "../../../../utils/validatesFields";
import { GenericForm, IGenericFormRefProps } from "../../../GenericForm";

interface IFormPersonModalProps {
  onCancel: Function;
  onSave: Function;
  defaultData?: userProps | null;
}

export const FormUser: React.FC<IFormPersonModalProps> = (props) => {
  const { onCancel, onSave, defaultData } = props;

  const { theme, notify } = useGlobal();
  const { api, consultsServices, user } = useApi();

  const [isEditPermitted, setIsEditPermitted] = useState(user?.user_type?.permissions?.includes("USERS-UPDATE"));

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setError,
    setValue,
    trigger,
  } = useForm({
    defaultValues: defaultData?.id ? defaultData : ({} as any),
    mode: "all",
  });

  const _form = watch();

  const form_ref = useRef<IGenericFormRefProps>(null);
  const submitButtonRef = useRef<HTMLButtonElement>(null);

  const [loadingCreate, setLoadingCreate] = useState(false);

  const onSubmit = useCallback(async () => {
    setLoadingCreate(true);

    try {
      const form = form_ref.current?.getForm();

      if (defaultData?.id) {
        await api.put(`/users/${defaultData?.id}`, form);
      } else {
        await api.post("/users/create", form);
      }

      notify(
        `Usuário ${defaultData?.id ? "atualizado" : "criado"} com sucesso!`,
        "success"
      );

      onSave();
    } catch (err: any) {
      const error = err.response ? err.response?.data : "SERVER ERROR";
      if (error.field)
        setError(error.field, { type: "manual", message: error.detail });
      else notify("ERRO INTERNO DO SISTEMA", "error");
    }

    setLoadingCreate(false);
  }, [form_ref, _form, api]);

  const handleStopPropagation = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e?.stopPropagation();
      handleSubmit(onSubmit)(e);
    },
    [handleSubmit, onSubmit, form_ref, _form, api]
  );

  const groups: IGroupProps[] = [
    {
      name: "",
      label: "",
      fields: [
        [
          {
            name: "surname",
            label: "Apelido",
            type: "input",
            required: true,
            getIsDisabled: () => !isEditPermitted,
          },
          {
            name: "email",
            label: "Email",
            type: "input",
            required: true,
            validate: validateEmail,
            getIsDisabled: () => !isEditPermitted,
          },
          {
            name: "password",
            label: "Senha",
            type: "input",
            required: !defaultData?.id,
            isPassword: true,
            getIsDisabled: () => !isEditPermitted,
          },
          {
            name: "user_type_id",
            label: "Tipo",
            type: "select-single-no-creatable",
            isClearable: true,
            required: true,
            searchOptions: consultsServices.user_type_id,
            getIsDisabled: () => !isEditPermitted,
          },
        ],
      ],
    },
  ];

  useEffect(() => {
    const inputs = document.getElementsByTagName("input");
    for (let i = 0; i < inputs.length; i++)
      inputs[i].setAttribute("autocomplete", "new-password");
  }, []);

  return (
    <>
      <Column style={{ flex: 1, overflow: "auto", padding: 20 }}>
        <ContainerForm open>
          <Form onSubmit={handleStopPropagation}>
            <GenericForm
              ref={form_ref}
              groups={groups}
              _form={_form}
              control={control}
              trigger={trigger}
              errors={errors}
              setValue={setValue}
              register={register}
            />
            <button
              className="display-none"
              type="submit"
              ref={submitButtonRef}
            />
          </Form>
        </ContainerForm>
      </Column>

      <ContainerButtons theme={theme}>
        {isEditPermitted && (
          <Button
            onClick={() => submitButtonRef.current?.click()}
            background={secondary[theme]}
            color={"#FFF"}
            style={{ padding: 8, maxWidth: 150, fontSize: 14 }}
            children={"Salvar"}
          />
        )}
      </ContainerButtons>

      <ModalLoading loading={loadingCreate} theme={theme} />
    </>
  );
};
